import { createFileRoute } from "@tanstack/react-router";
import AdminUsersPage from "@/pages/admin/users";

export const Route = createFileRoute("/app/admin/users")({
  component: AdminUsersPage,
});
